import { render, staticRenderFns } from "./jhlmsg.vue?vue&type=template&id=46a8cff4&scoped=true&"
import script from "./jhlmsg.vue?vue&type=script&lang=js&"
export * from "./jhlmsg.vue?vue&type=script&lang=js&"
import style0 from "./jhlmsg.vue?vue&type=style&index=0&id=46a8cff4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a8cff4",
  null
  
)

export default component.exports